import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EcitationSearchComponent } from './ecitation-search/ecitation-search.component';
import { EcitationHeaderComponent } from './ecitation-header/ecitation-header.component';
import { AllowPermissionDirective } from './allow-permission.directive';
import { AutoFocusDirective } from './auto-focus.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EcitationAllReportComponent } from './eCitationReports/ecitation-all-report/ecitation-all-report.component';
import { EcitationDeliveryAnnualReportComponent } from './eCitationReports/ecitation-delivery-annual-report/ecitation-delivery-annual-report.component';
import { EcitationAgencySummaryReportComponent } from './eCitationReports/ecitation-agency-summary-report/ecitation-agency-summary-report.component';
import { EcitationAgencyAnnualReportComponent } from './eCitationReports/ecitation-agency-annual-report/ecitation-agency-annual-report.component';
import { EcitationHourlyUsageReportComponent } from './eCitationReports/ecitation-hourly-usage-report/ecitation-hourly-usage-report.component';
import { EcitationDayofweekUsageReportComponent } from './eCitationReports/ecitation-dayofweek-usage-report/ecitation-dayofweek-usage-report.component';
import { EcitationDeliverySummaryReportComponent } from './eCitationReports/ecitation-delivery-summary-report/ecitation-delivery-summary-report.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { EcitationErrorDocSearchComponent } from './ecitation-error-doc-search/ecitation-error-doc-search.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { PublicCitationSearchComponent } from './public-citation-search/public-citation-search.component';
import { EcitationStatusComponent } from './admin-pages/ecitation-status/ecitation-status.component';
import { EcitationMuniStatusComponent } from './admin-pages/ecitation-muni-status/ecitation-muni-status.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { EcitationCourtComponent } from './admin-pages/ecitation-court/ecitation-court.component';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import { EcitationVendorComponent } from './admin-pages/ecitation-vendor/ecitation-vendor.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { EcitationLoginComponent } from './ecitation-login/ecitation-login.component';
import { EcitationUserComponent } from './admin-pages/ecitation-user/ecitation-user.component';
import { InterceptorService } from 'src/services/interceptor.service';
import { ControlMessageComponent } from './control-message/control-message.component';
import { ConformationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation-dialog.service';
import { AlertNotifyComponent } from './alert-notify/alert-notify.component';
import { AlertService } from './alert-notify/alert-notify.service';
import { LoaderComponent } from './loader/loader.component';
import { LoaderInterceptor } from 'src/services/loader.interceptor';
import { FooterComponent } from './footer/footer.component';
@NgModule({ declarations: [
        AppComponent,
        EcitationSearchComponent,
        EcitationHeaderComponent,
        AllowPermissionDirective,
        AutoFocusDirective,
        EcitationDeliverySummaryReportComponent,
        EcitationAllReportComponent,
        EcitationDeliveryAnnualReportComponent,
        EcitationAgencySummaryReportComponent,
        EcitationAgencyAnnualReportComponent,
        EcitationHourlyUsageReportComponent,
        EcitationDayofweekUsageReportComponent,
        EcitationErrorDocSearchComponent,
        PublicCitationSearchComponent,
        EcitationStatusComponent,
        EcitationMuniStatusComponent,
        HomeComponent,
        EcitationCourtComponent,
        EcitationVendorComponent,
        EcitationLoginComponent,
        EcitationUserComponent,
        ControlMessageComponent,
        ConformationDialogComponent,
        AlertNotifyComponent,
        LoaderComponent,
        FooterComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        BaseChartDirective,
        MatInputModule,
        MatFormFieldModule,
        MatStepperModule,
        MatButtonModule,
        MatButtonToggleModule], providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        ConfirmationDialogService,
        AlertService,
        provideCharts(withDefaultRegisterables()),
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' })),
    ] })
export class AppModule { }
